import React from "react";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { DataGrid } from "@mui/x-data-grid";
import { Fab, Card } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import api from "../../../components/services/api";
import DatePicker from "@mui/lab/DatePicker";
import TextField from "@mui/material/TextField";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";
import Alert from "@mui/material/Alert";
import Tooltip from "@mui/material/Tooltip";
import { useSelector } from "react-redux";
export default function Hightofwater() {
  const [data, setData] = useState([]);
  const [time, setTime] = useState([
    0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20,
    21, 22, 23,
  ]);
  const [YearSelect, setYearSelect] = useState("");
  const [MonthSelect, setMonthSelect] = useState("");
  const [DaySelect, setDaySelect] = useState("");
  const [HourSelect, setHourSelect] = useState("");
  const [WaterSelect, setWaterSelect] = useState("");
  const EmpId = localStorage.getItem("EmpId");
  const MenuActive = useSelector((state) => state.MenuActive.List);
  const [value, setValue] = useState(new Date());
  const [open, setOpen] = React.useState(false);
  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setDaySelect("");
    setHourSelect("");
    setWaterSelect("");
  };

  const confirm_update = async () => {
    const data = {
      year: YearSelect,
      month: MonthSelect,
      day: DaySelect,
      hour: HourSelect,
      water: WaterSelect,
      status: 1,
      createId: EmpId,
    };

    api
      .post("api/waterhight/create", data)
      .then((respose) => {
        const MySwal = withReactContent(Swal);
        setOpen(false);
        MySwal.fire({
          icon: "success",
          didOpen: () => {
            MySwal.clickConfirm();
          },
        }).then(() => {
          return MySwal.fire(
            "สำเร็จ!",
            "แก้ไขระดับน้ำสำเร็จ !",
            "success"
          ).then((result) => {
            if (result.isConfirmed) {
              getData(MonthSelect, YearSelect);
              setDaySelect("");
              setHourSelect("");
              setWaterSelect("");
              console.log(respose);
            }
          });
        });
        // console.log(respose);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  //fetch Data
  const getData = async (month, year) => {
    try {
      const data = await api.get(
        "api/waterhight/list?month=" + month + "&year=" + year
      );
      setData(data.data);
      setYearSelect(year);
      setMonthSelect(month);
      //   console.log(data.data);
    } catch (e) {
      console.log(e);
    }
  };

  return (
    <div>
      <Card variant="outlined" style={{ padding: "20px", margin: "25px" }}>
        <h6 style={{ marginTop: "10px" }} className="textcolorgreen">
          ตารางน้ำขึ้นน้ำลง
        </h6>

        <Grid container alignItems="center" spacing={1}>
          <Grid item xs>
            <Typography
              className="textcolordarkblue"
              variant="h5"
              component="h1"
            >
              Hight Of Water
            </Typography>
          </Grid>
          <Grid item sx={{ display: "flex", flexDirection: "row" }}>
            <Typography className="textcolorBule">Ship</Typography>
            <Typography>
              <span>&nbsp;</span> / Hight Of Water
            </Typography>
          </Grid>
        </Grid>

        <Grid
          style={{ marginTop: "10px", display: "flex", flexDirection: "row" }}
        >
          <div style={{ float: "right" }}>
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <DatePicker
                views={["year", "month"]}
                label="Year and Month"
                minDate={new Date("2012-03-01")}
                value={value}
                onChange={(newValue) => {
                  setValue(newValue);
                  let mount = newValue.getMonth() + 1;
                  let year = newValue.getFullYear();
                  if (mount && year !== undefined) {
                    getData(mount, year);
                  }
                }}
                renderInput={(params) => (
                  <TextField {...params} helperText={null} />
                )}
              />
            </LocalizationProvider>
          </div>
        </Grid>
        {data.length > 0 ? (
          <Box
            sx={{
              width: "100%",
              marginTop: "10px",
            }}
          >
            <TableContainer component={Paper}>
              <Table sx={{ minWidth: 650 }} aria-label="simple table">
                <TableHead>
                  <TableRow>
                    <TableCell>Day</TableCell>

                    {time.map((time, i) => (
                      <TableCell>{i}</TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {data.map((row, day) => (
                    <TableRow
                      key={row.day}
                      sx={{
                        "&:last-child td, &:last-child th": { border: 0 },
                      }}
                    >
                      <TableCell component="th" scope="row">
                        {day + 1}
                      </TableCell>

                      {time.map((time, i) => (
                        <TableCell sx={{ padding: 0 }}>
                          {/* {" "}
                        {console.log(row.hours[i].Water)} */}

                          {(row.hours.find((r, index) => +r.Hour === +time) && (
                            <>
                              {row.hours.find((r, index) => +r.Hour === +time)
                                ?.Water >= 2 ? (
                                <Tooltip
                                  title={
                                    row.hours.find(
                                      (r, index) => +r.Hour === +time
                                    )?.Water
                                  }
                                  arrow
                                >
                                  <Box
                                    sx={{
                                      bgcolor: "#007BFF",
                                      height: "100%",
                                      minHeight: "50px",
                                      margin: 0,
                                      p: 2,
                                    }}
                                    onClick={(e) => {
                                      //   console.log(row.hours[i]?.Hour);
                                      handleClickOpen();
                                      setDaySelect(day + 1);
                                      setHourSelect(time);
                                      setWaterSelect(
                                        row.hours.find(
                                          (r, index) => +r.Hour === +time
                                        )?.Water
                                      );
                                    }}
                                  ></Box>
                                </Tooltip>
                              ) : (
                                <Tooltip
                                  title={
                                    row.hours.find(
                                      (r, index) => +r.Hour === +time
                                    )?.Water
                                  }
                                  arrow
                                >
                                  <Box
                                    sx={{
                                      p: 2,
                                    }}
                                    onClick={(e) => {
                                      //   console.log(i + 1);
                                      handleClickOpen();
                                      setDaySelect(day + 1);
                                      setHourSelect(time);
                                      setWaterSelect(
                                        row.hours.find(
                                          (r, index) => +r.Hour === +time
                                        )?.Water
                                      );
                                    }}
                                  ></Box>
                                </Tooltip>
                              )}
                            </>
                          )) || (
                            <Tooltip title="0" arrow>
                              <Box
                                sx={{
                                  p: 2,
                                }}
                                onClick={(e) => {
                                  //   console.log(i + 1);
                                  handleClickOpen();
                                  setDaySelect(day + 1);
                                  setHourSelect(time);
                                  setWaterSelect(0);
                                }}
                              ></Box>
                            </Tooltip>
                          )}
                        </TableCell>
                      ))}
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        ) : (
          <Alert severity="success" style={{ marginTop: 10 }}>
            กรุณาเลือก เดือน-ปี ในการตรวจสอบระดับน้ำ
          </Alert>
        )}
      </Card>

      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>แก้ไขระดับน้ำ</DialogTitle>
        <DialogContent>
          <DialogContentText>
            คุณกำลังแก้ไขระดับน้ำวันที่{" "}
            {DaySelect +
              "/" +
              MonthSelect +
              "/" +
              YearSelect +
              " ชั่วโมง " +
              HourSelect}
          </DialogContentText>
          <TextField
            autoFocus
            margin="dense"
            label="ค่าระดับน้ำล่าสุด"
            value={WaterSelect}
            onChange={(e) => setWaterSelect(e.target.value)}
            type="number"
            InputProps={{ inputProps: { min: 0, max: 10 } }}
            fullWidth
            variant="standard"
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button onClick={confirm_update}>Update</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
